import React from "react"; // Replace with your vector image path
import GeometricCheckbox from "../../../app/features/header/icons/checkbox";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";

const PlatformFeatures: React.FC = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const features = [
    t("features.list.0"),
    t("features.list.1"),
    t("features.list.2"),
  ];
  return (
    <section className="flex flex-col items-center py-10 my-10">
      <h2 className="text-xl md:text-3xl lg:text-3xl font-bold mb-6 text-gray-800">
        {t("features.title")}
      </h2>
      <div className="mt-10 md:px-6 w-full md:max-w-6xl">
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 it md:justify-items-center gap-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-center gap-3 p-4 rounded-lg transition-transform transform hover:scale-105"
            >
              <GeometricCheckbox />
              <p className="text-lg font-medium text-gray-700">{feature}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformFeatures;
